import { render, staticRenderFns } from "./configuration.vue?vue&type=template&id=ff89b036&scoped=true&"
import script from "./configuration.vue?vue&type=script&lang=ts&"
export * from "./configuration.vue?vue&type=script&lang=ts&"
import style0 from "./configuration.vue?vue&type=style&index=0&id=ff89b036&lang=scss&scoped=true&"
import style1 from "./configuration.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff89b036",
  null
  
)

export default component.exports